export const isPlatformBrowser = () => typeof window !== 'undefined';
